import React from 'react';
import { Button } from "../../../button/index.js";
import { FormLayout } from "../../../formLayout/FormLayout.js";
import { Skeleton } from "../../../skeleton/Skeleton.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function CustomButton({
  element,
  isLoading
}) {
  return /*#__PURE__*/_jsx(FormLayout, {
    spacing: element.componentProps.spacing ?? true,
    children: /*#__PURE__*/_jsx(Skeleton, {
      loading: isLoading,
      minHeight: "49px",
      children: /*#__PURE__*/_jsx(Button, {
        ...element.componentProps
      })
    })
  });
}